import { PageTitle } from '@/components/seo/page-title';
import { DeleteAccountScreen } from '@/screens/settings/delete-account-screen';
import React from 'react';

export default function DeleteAccountRoute() {
  return (
    <>
      <PageTitle title="Delete Account" />
      <DeleteAccountScreen />
    </>
  );
}
